import { render, staticRenderFns } from "./Invoicemanger.vue?vue&type=template&id=bfbfa894&scoped=true"
import script from "./Invoicemanger.vue?vue&type=script&lang=js"
export * from "./Invoicemanger.vue?vue&type=script&lang=js"
import style0 from "./Invoicemanger.vue?vue&type=style&index=0&id=bfbfa894&prod&lang=scss&scoped=true"
import style1 from "./Invoicemanger.vue?vue&type=style&index=1&id=bfbfa894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbfa894",
  null
  
)

export default component.exports